module.exports = __webpack_public_path__ + "img/bg-login.55626f7c.jpg";